var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextDecor2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2412 38.1624C23.777 41.8956 30.7205 44.9733 37.4284 48.4443",
    stroke: "url(#paint0_linear_78_3441)",
    strokeWidth: 1.10917,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6807 19.4994C24.4417 28.2083 33.4418 36.3335 42.6463 43.9377",
    stroke: "url(#paint1_linear_78_3441)",
    strokeWidth: 1.10917,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8672 16.7413C40.2422 24.142 45.9525 33.9765 49.4903 41.1277",
    stroke: "url(#paint2_linear_78_3441)",
    strokeWidth: 1.10917,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7051 55.2988C59.3749 55.2816 61.2256 55.1851 61.8911 55.1323C62.241 56.2194 62.3897 57.0625 62.4781 58.0793C61.7549 58.1257 60.5954 58.3417 59.874 58.4082C60.2916 58.6836 61.2185 59.3903 61.641 59.6605C60.8147 60.5023 59.9433 61.3678 59.0088 62.1217C58.5632 61.7638 57.5787 61.0047 57.1315 60.6481C57.1313 61.1587 56.9807 62.2901 56.9327 62.7993C55.9314 62.7841 54.8598 62.8172 53.876 62.6907C53.8627 61.8919 53.9867 60.4728 53.9607 59.6745C53.7919 59.673 51.2493 59.9264 50.4862 59.9301C50.1812 59.0213 50.0361 58.0741 49.9275 57.135C50.5936 57.1104 51.9388 56.9958 52.6048 56.974C52.1224 56.4153 51.3617 55.7728 50.4335 54.9248C51.3933 54.1705 52.2423 53.3238 53.2231 52.5866C53.7263 53.031 54.9759 53.832 55.4996 54.259C55.6723 53.4251 55.8415 52.5741 55.9139 51.7287C56.9676 51.8888 58.0097 52.0674 59.0367 52.322C58.9512 53.1978 58.7954 54.4883 58.7051 55.2988Z",
    stroke: "white",
    strokeWidth: 1.10917,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_3441",
    x1: 27.3348,
    y1: 48.4443,
    x2: 29.0336,
    y2: 38.4512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515056,
    stopColor: "#A070FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB35C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_78_3441",
    x1: 29.6635,
    y1: 43.9377,
    x2: 36.6509,
    y2: 21.6944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515056,
    stopColor: "#A070FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB35C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_78_3441",
    x1: 44.1787,
    y1: 41.1277,
    x2: 55.952,
    y2: 25.7619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515056,
    stopColor: "#A070FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB35C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextDecor2);
export default __webpack_public_path__ + "static/media/text-decor-2.acaaad00b64d26b38114c3ecaefac8eb.svg";
export { ForwardRef as ReactComponent };